import { InjectionToken } from '@angular/core';

export const DIALOG_MAX_HEIGHT_TOKEN = new InjectionToken<string>("DialogMaxHeight");
